import { IArboristTreeNode, IJSTreeNode } from "../models/Interfaces";

export class TreeHelper {
    // SEO titles may contain "|" sections; show only the first part in trees
    static getDisplayName = (name: string): string => {
      const firstPart = (name ?? "").split("|")[0].trim();
      return firstPart || name;
    };

    static buildTreeDataH = (treedata: IJSTreeNode[]): IArboristTreeNode[] => {
        const tree: { [key: string]: IArboristTreeNode } = {}; // For quick lookup by id
        const rootNodes: IArboristTreeNode[] = []; // This will store the root nodes
    
        // Initialize all nodes and set children arrays
        treedata.forEach((node) => {
          // Convert JsTreeNode to ArboristNode
          tree[node.id] = { 
            id: node.id.toString(), 
            name: node.text,
            alias: node.alias,  // Map 'text' to 'name' for arborist
            url: node.url,
            language: node.language,
            type: node.type,
            children: []  // Initialize the children array for every node
          };
        });
    
        // Build the tree by associating child nodes with their parent
        treedata.forEach((node) => {
          if (node.parent === "#" || node.parent === null) {
            // Root nodes are directly added to rootNodes array
            rootNodes.push(tree[node.id]);
          } else {
            // If the node has a parent, find its parent and add it as a child
            if (tree[node.parent]) {
              tree[node.parent].children.push(tree[node.id]);
            }
          }
        });
    
        return rootNodes;
    };

    static buildTreeDataF = (treedata: Array<IJSTreeNode>) : Array<IArboristTreeNode> => {
      const flatdata = treedata.map(td => {
        return {
          id: td.id.toString(), 
          name: td.text,  // Map 'text' to 'name' for arborist
          url: td.url,
          language: td.language,
          type: td.type,
          parentId: td.parent === "#" ? null : td.parent
        }
      });
      return flatdata as Array<IArboristTreeNode>;
    }
}